// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pdy5HlKKzjAdD_bg4K7y {
  width: 100%;
  margin-top: 24px;
  padding: 24px;
  background: var(--dst-surface);
  border-radius: 14px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.09);
  box-sizing: border-box;
}

.oHDVWqvD08I01seRwYMS {
  font-size: 2.1em;
  font-weight: 700;
  letter-spacing: 1px;
  margin: 0 0 16px 0;
  color: var(--dst-text);
}

.yC9G5cxkMwXy3Z7qJruG {
  width: 100%;
}

.Q1vjTMe0koCc0HrT6usD {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.BUIe1OcV0hX9MoPRZmzN {
  margin: 0;
  font-size: 1.2rem;
  color: var(--dst-primary, #205ec8);
}

.O9cBgtAUf7fUaEq7xBtP { order: -2; }
.jPdPlKqtMDJIpMeQJB20 { order: -1; }

.DUxc3x1VWbjbyaFUbMMX {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 12px;
}

.nByPCR0Hy5X_7clLIuMs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.WDvY2Kc2J3b55K89E9gA {
  border: 1px solid var(--dst-card-border);
  border-radius: 10px;
  background: var(--dst-card-bg);
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.VIoxDTnkzlRm4EffuCbo {
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--dst-muted);
  font-weight: 700;
}

.MT17rhT_TAbjY2m9tLIp {
  font-size: 1.15rem;
  color: var(--dst-text);
  font-weight: 700;
}

.pl_mP_x4iKTwUNO_DacI {
  cursor: pointer;
  color: var(--dst-text);
  font-weight: 700;
}

.G1tB2t713V7imv9wwXlo {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.prciel1gBeY0LDQetjqn,
.f1WPLFl4od__MYqmLots {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.f1WPLFl4od__MYqmLots {
  grid-column: 1 / -1;
}

.prciel1gBeY0LDQetjqn span,
.f1WPLFl4od__MYqmLots span {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--dst-text);
}

.prciel1gBeY0LDQetjqn input,
.prciel1gBeY0LDQetjqn select,
.f1WPLFl4od__MYqmLots input,
.f1WPLFl4od__MYqmLots textarea {
  min-height: 44px;
  border: 1px solid var(--dst-input-border);
  border-radius: 8px;
  padding: 9px 10px;
  font-size: 0.95rem;
  background: var(--dst-input-bg);
  color: var(--dst-text);
}

.uDCpMdHI8xmqqbBXzJQ0 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.OQSBzu203w25MQnOsgJV,
.yCgLRKU5mnn0EDcfEnpc,
._0tswTd064ryHAQXuNuhH,
.DjzfrBHzbKqPNuP_GQDQ {
  border: 1px solid transparent;
  border-radius: 8px;
  min-height: 44px;
  padding: 8px 12px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  touch-action: manipulation;
}

.OQSBzu203w25MQnOsgJV {
  background: var(--dst-primary, #205ec8);
  color: #fff;
}

.yCgLRKU5mnn0EDcfEnpc {
  background: var(--dst-info-bg);
  color: var(--dst-info-text);
  border-color: var(--dst-info-border);
}

._0tswTd064ryHAQXuNuhH {
  background: var(--dst-error-text);
  color: #fff;
}

.DjzfrBHzbKqPNuP_GQDQ {
  background: var(--dst-input-bg);
  border-color: var(--dst-border);
  color: var(--dst-text);
  min-height: 36px;
  padding: 5px 8px;
}

.OQSBzu203w25MQnOsgJV:disabled,
.yCgLRKU5mnn0EDcfEnpc:disabled,
._0tswTd064ryHAQXuNuhH:disabled,
.DjzfrBHzbKqPNuP_GQDQ:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.AnDalMcPq0CYXSlSxMKR,
.GenvckQ_eUjOyUtWAJO6 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.GenvckQ_eUjOyUtWAJO6 {
  max-height: 290px;
  overflow-y: auto;
}

._UgcDI7_fv3LC2qI_VGT,
.Stg9wO89LbDkJww_TaNv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid var(--dst-border);
  border-radius: 8px;
  padding: 8px 10px;
  background: var(--dst-input-bg);
}

.MF0ukVZFhbUCdH7w8BTf {
  cursor: grab;
  user-select: none;
}

.MF0ukVZFhbUCdH7w8BTf:focus-visible {
  outline: 3px solid rgba(32, 94, 200, 0.45);
  outline-offset: 1px;
}

.MF0ukVZFhbUCdH7w8BTf:active {
  cursor: grabbing;
}

.fhrK7RKOnKvJlYqBz012 {
  display: inline-block;
  margin-right: 8px;
  color: var(--dst-muted);
  font-weight: 700;
  letter-spacing: 0.06em;
}

.N8bNh6Vd0kHAqqPwCY4z {
  opacity: 0.6;
  border-style: dashed;
}

.jpAe8ZgEXJFZmEZLMBR6 {
  border-color: var(--dst-primary, #205ec8);
  box-shadow: 0 0 0 1px rgba(32, 94, 200, 0.25);
}

.To5D82fjeNk_HCqKg4BC {
  display: flex;
  gap: 6px;
}

.pLm_47AmWZtXC8yCJSQ9 {
  margin: 0;
  border: 1px solid var(--dst-border);
  background: var(--dst-panel-subtle);
  border-radius: 10px;
  padding: 10px;
  font-size: 0.8rem;
  overflow-x: auto;
}

.nIuSpDWClAFirBz_rbBk,
.BdfKCWLx0Sbxlq7uldP8 {
  border-radius: 8px;
  padding: 9px 10px;
  font-size: 0.9rem;
  margin-bottom: 12px;
}

.nIuSpDWClAFirBz_rbBk {
  background: var(--dst-success-bg);
  color: var(--dst-success-text);
  border: 1px solid var(--dst-success-border);
}

.BdfKCWLx0Sbxlq7uldP8 {
  background: var(--dst-error-bg);
  color: var(--dst-error-text);
  border: 1px solid var(--dst-error-border);
}

.q8c_05G7JyOHNt43JILj,
.NT4I8J0HE4ROIuDipwON {
  margin: 0;
  color: var(--dst-muted);
  font-size: 0.9rem;
}

.yYiG5JUGxuEiLyQlg9qI {
  margin: 0;
  padding-left: 18px;
  color: var(--dst-text);
  display: grid;
  gap: 7px;
}

.IM2dUZ0Uoif_tuH_qYiu {
  margin: 2px 0 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--dst-text);
}

.vIIO4CsoLs3lZ385Z6vc {
  border: 1px solid var(--dst-info-border);
  background: var(--dst-info-bg);
  color: var(--dst-info-text);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.9rem;
}

.kl1HXaNtSEU0cr_4q3sX {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--dst-table-border);
  border-radius: 10px;
  background: var(--dst-card-bg);
}

.cfEwaNlF8HPIRzm3Zo1k {
  width: 100%;
  border-collapse: collapse;
  min-width: 860px;
}

.K2SNI0vv7TCU_VIVY6Tu {
  min-width: 680px;
}

.cfEwaNlF8HPIRzm3Zo1k th,
.cfEwaNlF8HPIRzm3Zo1k td {
  border-bottom: 1px solid var(--dst-table-border);
  padding: 8px;
  text-align: left;
  font-size: 0.88rem;
  vertical-align: middle;
}

.cfEwaNlF8HPIRzm3Zo1k td {
  color: var(--dst-table-text);
  background: var(--dst-table-bg);
}

.cfEwaNlF8HPIRzm3Zo1k th {
  background: var(--dst-table-head-bg);
  color: var(--dst-table-head-text);
  font-weight: 700;
}

._MwkwH74zX1ZpV1QtkAj {
  width: 100%;
  min-width: 170px;
  min-height: 40px;
  border: 1px solid var(--dst-input-border);
  border-radius: 8px;
  padding: 6px 8px;
  font-size: 0.85rem;
  background: var(--dst-input-bg);
  color: var(--dst-text);
}

.xd_28fvPnyJ4_z6ISFVw {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
}

.AdSGW8YejTO2jbAX59Kq {
  min-width: 250px;
}

.GbEcYGEbnbbf7uOh6tc6 {
  text-align: center;
  color: var(--dst-muted);
  padding: 18px 8px;
}

.PGHENAx09Hc4tTTVrcKQ {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.prciel1gBeY0LDQetjqn input:focus-visible,
.prciel1gBeY0LDQetjqn select:focus-visible,
.f1WPLFl4od__MYqmLots textarea:focus-visible,
._MwkwH74zX1ZpV1QtkAj:focus-visible,
.OQSBzu203w25MQnOsgJV:focus-visible,
.yCgLRKU5mnn0EDcfEnpc:focus-visible,
._0tswTd064ryHAQXuNuhH:focus-visible,
.DjzfrBHzbKqPNuP_GQDQ:focus-visible {
  outline: 3px solid rgba(32, 94, 200, 0.45);
  outline-offset: 2px;
}

.Zri4zSs3f3TbmBRg44it {
  padding: 10px;
  text-align: left;
  font-size: 0.85rem;
  color: var(--dst-muted);
}

/* Color picker grid */
.IR6ez8EPHVw3rgjgLB9v {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
  margin-top: 8px;
}

.WR3C38dEDlXlLSMSt9fU {
  display: flex;
  flex-direction: column;
}

.WR3C38dEDlXlLSMSt9fU label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
}

.WR3C38dEDlXlLSMSt9fU label span:first-child {
  flex: 1;
  color: var(--dst-fg);
}

.WR3C38dEDlXlLSMSt9fU input[type="color"] {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid var(--dst-border);
  cursor: pointer;
  padding: 2px;
  background: none;
  flex-shrink: 0;
}

.lhuVZKzwChyQc1CZT49f {
  font-family: monospace;
  font-size: 0.85rem;
  color: var(--dst-muted);
  min-width: 60px;
}

/* Live preview */
.PsL4HrMlEkTKGCezarPo {
  margin-top: 8px;
}

/* Docs reference layout */
.wK5DRBQ7lCaRXiruyz9Q {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.hzvDj7qt12GxWau6jxTy {
  padding: 14px;
  border-radius: 8px;
  background: var(--dst-panel-subtle);
  border: 1px solid var(--dst-border);
}

.hzvDj7qt12GxWau6jxTy h5 {
  margin: 0 0 6px 0;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--dst-text);
  display: flex;
  align-items: center;
  gap: 8px;
}

.hzvDj7qt12GxWau6jxTy p {
  margin: 0;
  font-size: 0.875rem;
  color: var(--dst-muted);
  line-height: 1.5;
}

/* Badge for Pro/Free labels */
.KgQTVZTqPxuBulQeOitH {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  background: var(--dst-primary, #205ec8);
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

/* Ordered list for docs */
ol.yYiG5JUGxuEiLyQlg9qI {
  padding-left: 20px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

ol.yYiG5JUGxuEiLyQlg9qI li {
  font-size: 0.9rem;
  color: var(--dst-text);
  line-height: 1.5;
}

@media (max-width: 768px) {
  .Pdy5HlKKzjAdD_bg4K7y {
    padding: 16px 12px;
  }

  .oHDVWqvD08I01seRwYMS {
    font-size: 1.4rem;
    margin-bottom: 12px;
  }

  .nByPCR0Hy5X_7clLIuMs,
  .G1tB2t713V7imv9wwXlo {
    grid-template-columns: 1fr;
  }

  .cfEwaNlF8HPIRzm3Zo1k {
    min-width: 700px;
  }

  .xd_28fvPnyJ4_z6ISFVw {
    flex-direction: column;
    align-items: stretch;
  }

  ._MwkwH74zX1ZpV1QtkAj {
    min-width: 140px;
  }
}
`, "",{"version":3,"sources":["webpack://./assets/js/src/components/AdminDashboard/AdminDashboard.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,wBAAmB,SAAS,EAAE;AAC9B,wBAAgB,SAAS,EAAE;;AAE3B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;EAIE,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;;;EAIE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;;EAIE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gDAAgD;EAChD,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;;;;;;EAQE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".container {\n  width: 100%;\n  margin-top: 24px;\n  padding: 24px;\n  background: var(--dst-surface);\n  border-radius: 14px;\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.09);\n  box-sizing: border-box;\n}\n\n.title {\n  font-size: 2.1em;\n  font-weight: 700;\n  letter-spacing: 1px;\n  margin: 0 0 16px 0;\n  color: var(--dst-text);\n}\n\n.content {\n  width: 100%;\n}\n\n.section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.sectionTitle {\n  margin: 0;\n  font-size: 1.2rem;\n  color: var(--dst-primary, #205ec8);\n}\n\n.patrolPageTitle { order: -2; }\n.patrolEditor { order: -1; }\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n  gap: 12px;\n}\n\n.gridThree {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.card {\n  border: 1px solid var(--dst-card-border);\n  border-radius: 10px;\n  background: var(--dst-card-bg);\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.cardLabel {\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--dst-muted);\n  font-weight: 700;\n}\n\n.cardValue {\n  font-size: 1.15rem;\n  color: var(--dst-text);\n  font-weight: 700;\n}\n\n.archiveSummary {\n  cursor: pointer;\n  color: var(--dst-text);\n  font-weight: 700;\n}\n\n.formGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.field,\n.fieldWide {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.fieldWide {\n  grid-column: 1 / -1;\n}\n\n.field span,\n.fieldWide span {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--dst-text);\n}\n\n.field input,\n.field select,\n.fieldWide input,\n.fieldWide textarea {\n  min-height: 44px;\n  border: 1px solid var(--dst-input-border);\n  border-radius: 8px;\n  padding: 9px 10px;\n  font-size: 0.95rem;\n  background: var(--dst-input-bg);\n  color: var(--dst-text);\n}\n\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.primaryButton,\n.secondaryButton,\n.dangerButton,\n.smallButton {\n  border: 1px solid transparent;\n  border-radius: 8px;\n  min-height: 44px;\n  padding: 8px 12px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  touch-action: manipulation;\n}\n\n.primaryButton {\n  background: var(--dst-primary, #205ec8);\n  color: #fff;\n}\n\n.secondaryButton {\n  background: var(--dst-info-bg);\n  color: var(--dst-info-text);\n  border-color: var(--dst-info-border);\n}\n\n.dangerButton {\n  background: var(--dst-error-text);\n  color: #fff;\n}\n\n.smallButton {\n  background: var(--dst-input-bg);\n  border-color: var(--dst-border);\n  color: var(--dst-text);\n  min-height: 36px;\n  padding: 5px 8px;\n}\n\n.primaryButton:disabled,\n.secondaryButton:disabled,\n.dangerButton:disabled,\n.smallButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.stack,\n.stackCompact {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.stackCompact {\n  max-height: 290px;\n  overflow-y: auto;\n}\n\n.orderRow,\n.listRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  border: 1px solid var(--dst-border);\n  border-radius: 8px;\n  padding: 8px 10px;\n  background: var(--dst-input-bg);\n}\n\n.draggableRow {\n  cursor: grab;\n  user-select: none;\n}\n\n.draggableRow:focus-visible {\n  outline: 3px solid rgba(32, 94, 200, 0.45);\n  outline-offset: 1px;\n}\n\n.draggableRow:active {\n  cursor: grabbing;\n}\n\n.dragHandle {\n  display: inline-block;\n  margin-right: 8px;\n  color: var(--dst-muted);\n  font-weight: 700;\n  letter-spacing: 0.06em;\n}\n\n.draggingRow {\n  opacity: 0.6;\n  border-style: dashed;\n}\n\n.dropTargetRow {\n  border-color: var(--dst-primary, #205ec8);\n  box-shadow: 0 0 0 1px rgba(32, 94, 200, 0.25);\n}\n\n.rowActions {\n  display: flex;\n  gap: 6px;\n}\n\n.codeBlock {\n  margin: 0;\n  border: 1px solid var(--dst-border);\n  background: var(--dst-panel-subtle);\n  border-radius: 10px;\n  padding: 10px;\n  font-size: 0.8rem;\n  overflow-x: auto;\n}\n\n.success,\n.error {\n  border-radius: 8px;\n  padding: 9px 10px;\n  font-size: 0.9rem;\n  margin-bottom: 12px;\n}\n\n.success {\n  background: var(--dst-success-bg);\n  color: var(--dst-success-text);\n  border: 1px solid var(--dst-success-border);\n}\n\n.error {\n  background: var(--dst-error-bg);\n  color: var(--dst-error-text);\n  border: 1px solid var(--dst-error-border);\n}\n\n.helpText,\n.muted {\n  margin: 0;\n  color: var(--dst-muted);\n  font-size: 0.9rem;\n}\n\n.docsList {\n  margin: 0;\n  padding-left: 18px;\n  color: var(--dst-text);\n  display: grid;\n  gap: 7px;\n}\n\n.docsSubheading {\n  margin: 2px 0 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--dst-text);\n}\n\n.noticeBox {\n  border: 1px solid var(--dst-info-border);\n  background: var(--dst-info-bg);\n  color: var(--dst-info-text);\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 0.9rem;\n}\n\n.tableWrap {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid var(--dst-table-border);\n  border-radius: 10px;\n  background: var(--dst-card-bg);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 860px;\n}\n\n.compactTable {\n  min-width: 680px;\n}\n\n.table th,\n.table td {\n  border-bottom: 1px solid var(--dst-table-border);\n  padding: 8px;\n  text-align: left;\n  font-size: 0.88rem;\n  vertical-align: middle;\n}\n\n.table td {\n  color: var(--dst-table-text);\n  background: var(--dst-table-bg);\n}\n\n.table th {\n  background: var(--dst-table-head-bg);\n  color: var(--dst-table-head-text);\n  font-weight: 700;\n}\n\n.inlineInput {\n  width: 100%;\n  min-width: 170px;\n  min-height: 40px;\n  border: 1px solid var(--dst-input-border);\n  border-radius: 8px;\n  padding: 6px 8px;\n  font-size: 0.85rem;\n  background: var(--dst-input-bg);\n  color: var(--dst-text);\n}\n\n.inlineActions {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.actionsCell {\n  min-width: 250px;\n}\n\n.emptyCell {\n  text-align: center;\n  color: var(--dst-muted);\n  padding: 18px 8px;\n}\n\n.visuallyHidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.field input:focus-visible,\n.field select:focus-visible,\n.fieldWide textarea:focus-visible,\n.inlineInput:focus-visible,\n.primaryButton:focus-visible,\n.secondaryButton:focus-visible,\n.dangerButton:focus-visible,\n.smallButton:focus-visible {\n  outline: 3px solid rgba(32, 94, 200, 0.45);\n  outline-offset: 2px;\n}\n\n.caption {\n  padding: 10px;\n  text-align: left;\n  font-size: 0.85rem;\n  color: var(--dst-muted);\n}\n\n/* Color picker grid */\n.colorGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 16px;\n  margin-top: 8px;\n}\n\n.colorField {\n  display: flex;\n  flex-direction: column;\n}\n\n.colorField label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.colorField label span:first-child {\n  flex: 1;\n  color: var(--dst-fg);\n}\n\n.colorField input[type=\"color\"] {\n  width: 44px;\n  height: 44px;\n  border-radius: 8px;\n  border: 1px solid var(--dst-border);\n  cursor: pointer;\n  padding: 2px;\n  background: none;\n  flex-shrink: 0;\n}\n\n.colorValue {\n  font-family: monospace;\n  font-size: 0.85rem;\n  color: var(--dst-muted);\n  min-width: 60px;\n}\n\n/* Live preview */\n.previewTable {\n  margin-top: 8px;\n}\n\n/* Docs reference layout */\n.docReference {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.refItem {\n  padding: 14px;\n  border-radius: 8px;\n  background: var(--dst-panel-subtle);\n  border: 1px solid var(--dst-border);\n}\n\n.refItem h5 {\n  margin: 0 0 6px 0;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--dst-text);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.refItem p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--dst-muted);\n  line-height: 1.5;\n}\n\n/* Badge for Pro/Free labels */\n.badge {\n  display: inline-block;\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: var(--dst-primary, #205ec8);\n  color: #fff;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n/* Ordered list for docs */\nol.docsList {\n  padding-left: 20px;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\nol.docsList li {\n  font-size: 0.9rem;\n  color: var(--dst-text);\n  line-height: 1.5;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 16px 12px;\n  }\n\n  .title {\n    font-size: 1.4rem;\n    margin-bottom: 12px;\n  }\n\n  .gridThree,\n  .formGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .table {\n    min-width: 700px;\n  }\n\n  .inlineActions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .inlineInput {\n    min-width: 140px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Pdy5HlKKzjAdD_bg4K7y`,
	"title": `oHDVWqvD08I01seRwYMS`,
	"content": `yC9G5cxkMwXy3Z7qJruG`,
	"section": `Q1vjTMe0koCc0HrT6usD`,
	"sectionTitle": `BUIe1OcV0hX9MoPRZmzN`,
	"patrolPageTitle": `O9cBgtAUf7fUaEq7xBtP`,
	"patrolEditor": `jPdPlKqtMDJIpMeQJB20`,
	"grid": `DUxc3x1VWbjbyaFUbMMX`,
	"gridThree": `nByPCR0Hy5X_7clLIuMs`,
	"card": `WDvY2Kc2J3b55K89E9gA`,
	"cardLabel": `VIoxDTnkzlRm4EffuCbo`,
	"cardValue": `MT17rhT_TAbjY2m9tLIp`,
	"archiveSummary": `pl_mP_x4iKTwUNO_DacI`,
	"formGrid": `G1tB2t713V7imv9wwXlo`,
	"field": `prciel1gBeY0LDQetjqn`,
	"fieldWide": `f1WPLFl4od__MYqmLots`,
	"actions": `uDCpMdHI8xmqqbBXzJQ0`,
	"primaryButton": `OQSBzu203w25MQnOsgJV`,
	"secondaryButton": `yCgLRKU5mnn0EDcfEnpc`,
	"dangerButton": `_0tswTd064ryHAQXuNuhH`,
	"smallButton": `DjzfrBHzbKqPNuP_GQDQ`,
	"stack": `AnDalMcPq0CYXSlSxMKR`,
	"stackCompact": `GenvckQ_eUjOyUtWAJO6`,
	"orderRow": `_UgcDI7_fv3LC2qI_VGT`,
	"listRow": `Stg9wO89LbDkJww_TaNv`,
	"draggableRow": `MF0ukVZFhbUCdH7w8BTf`,
	"dragHandle": `fhrK7RKOnKvJlYqBz012`,
	"draggingRow": `N8bNh6Vd0kHAqqPwCY4z`,
	"dropTargetRow": `jpAe8ZgEXJFZmEZLMBR6`,
	"rowActions": `To5D82fjeNk_HCqKg4BC`,
	"codeBlock": `pLm_47AmWZtXC8yCJSQ9`,
	"success": `nIuSpDWClAFirBz_rbBk`,
	"error": `BdfKCWLx0Sbxlq7uldP8`,
	"helpText": `q8c_05G7JyOHNt43JILj`,
	"muted": `NT4I8J0HE4ROIuDipwON`,
	"docsList": `yYiG5JUGxuEiLyQlg9qI`,
	"docsSubheading": `IM2dUZ0Uoif_tuH_qYiu`,
	"noticeBox": `vIIO4CsoLs3lZ385Z6vc`,
	"tableWrap": `kl1HXaNtSEU0cr_4q3sX`,
	"table": `cfEwaNlF8HPIRzm3Zo1k`,
	"compactTable": `K2SNI0vv7TCU_VIVY6Tu`,
	"inlineInput": `_MwkwH74zX1ZpV1QtkAj`,
	"inlineActions": `xd_28fvPnyJ4_z6ISFVw`,
	"actionsCell": `AdSGW8YejTO2jbAX59Kq`,
	"emptyCell": `GbEcYGEbnbbf7uOh6tc6`,
	"visuallyHidden": `PGHENAx09Hc4tTTVrcKQ`,
	"caption": `Zri4zSs3f3TbmBRg44it`,
	"colorGrid": `IR6ez8EPHVw3rgjgLB9v`,
	"colorField": `WR3C38dEDlXlLSMSt9fU`,
	"colorValue": `lhuVZKzwChyQc1CZT49f`,
	"previewTable": `PsL4HrMlEkTKGCezarPo`,
	"docReference": `wK5DRBQ7lCaRXiruyz9Q`,
	"refItem": `hzvDj7qt12GxWau6jxTy`,
	"badge": `KgQTVZTqPxuBulQeOitH`
};
export default ___CSS_LOADER_EXPORT___;
